var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{attrs:{"bordered":false}},[_c('register-result',{attrs:{"is-success":false,"title":_vm.title,"description":_vm.description,"content":false}},[_c('template',{slot:"action"})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }